import { render, staticRenderFns } from "./StudyOnline4.vue?vue&type=template&id=b53b350e&scoped=true"
import script from "./StudyOnline4.vue?vue&type=script&lang=js"
export * from "./StudyOnline4.vue?vue&type=script&lang=js"
import style0 from "./StudyOnline4.vue?vue&type=style&index=0&id=b53b350e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53b350e",
  null
  
)

export default component.exports